import React from 'react'
import { Typography, makeStyles } from '@material-ui/core';
import { formErrorMessage } from '../../utils/formErrorMessage';

const useStyles = makeStyles((theme) => ({
    error: {
        color: "#ff3860",
        fontSize: "1.1rem",
        marginTop: "0.25rem",
        fontStyle: 'italic',
    },
}));

const FieldError = ({ errors, customErrorMessage = null }) => {
    const classes = useStyles();

    if (!errors) return null;

    return (
        <Typography variant="body2" className={classes.error}>
            {formErrorMessage(errors, customErrorMessage)}
        </Typography>
    );
}

export default FieldError;
